import styled, { createGlobalStyle } from 'styled-components';
import ButtonIcon from 'components/ButtonIcon';
import LoadingShape from 'components/LoadingShape';

export const Container = styled.div`
    display: flex;
    gap: 0.75rem;
    align-items: center;
    padding: 0.5rem;
    background-color: #f5f5f5;
    border-radius: 100px;
    height: 4rem;
    box-sizing: border-box;
`;

export const PlayButton = styled(ButtonIcon)`
    flex-shrink: 0;
    border-radius: 100% !important;
`;

export const TimeLineContainer = styled.div`
    display: inline-flex;
    flex: 1;
`;

export const StyledLoadingShape = styled(LoadingShape)`
    div {
        border-radius: 100px !important;
    }
`;

export const WaveformGlobalStyle = createGlobalStyle`
    #wave ::part(cursor) {
        border-radius: 0;
    }
`;

export const Wave = styled.div`
    display: inlinie-flex;
    flex: 1;
    box-sizing: border-box;
    height: 3rem;
`;
